
import { encryptor } from "../../Services/Crypto/Crypto";
import { PrivateInterceptor } from "../../interceptors/PrivateInterceptor";




export const loginUser = async (user, password) => {

    let ip = null;
    let result = null;

    // Funcion para obtener la IP de la maquina desde la API `https://geolocation-db.com/`
    // const getData = async () => {
    //     // TODO PETICION -> FUNCION VERIFICAR QUE LA API FUNCIONE Y OBTENGA LA IP
    //     const promesa = await fetch('https://geolocation-db.com/json/8dd79c70-0801-11ec-a29f-e381a788c2c0')
    //     await promesa.json()
    //         .then((res) => {
    //             setIP(res.IPv4)
    //         })
    //         .catch((error) => {
    //             console.error(error);
    //         })
    // }

    const usuarioBase64 = await encryptor(user);
    const passwordBase64 = await encryptor(password);
    const promesa = await fetch(`${process.env.REACT_APP_API_URL}/IT/Users/login?${Date.now()}`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            withCredentials: true,
        },
        body: JSON.stringify({
            Usuario: usuarioBase64,
            Password: passwordBase64,
            IP: ip,
            subscription: null,
            divece: 'web'
        })
    })
    await promesa.json()
        .then(async (res) => {
            result = res;
        })
        .catch((error) => {
            console.log('error', error);
        })
    return result;
}


// OBTENER LOS PERMISOS DE UN USUARIO
export const getPermisos = async (idUser) => {
    const respuesta = await PrivateInterceptor(`IT/Permisos/${idUser}`, 'GET')
    return respuesta;
}

export const getAccesos = async (idUser) => {
    const respuesta = await PrivateInterceptor(`IT/Accesos/${idUser}`, 'GET')
    return respuesta;
}


// ACTUALIZA EL TIEMPO DE VENCIMIENTO DEL TOKEN DEL USUARIO
export const VencimientoToken = async (idUser) => {
    const respuesta = await PrivateInterceptor(`IT/Sesiones/${idUser}`, 'PUT')
    return respuesta;
}

export const continuarSesion = async () => {
    const respuesta = await PrivateInterceptor(`IT/Users/getNewToken`, 'GET');
    return respuesta;
}

// cambiar webconfig
export const changeWebConfig = async (idUser, WebConfig) => {
    const result = await PrivateInterceptor(`IT/Users/changeWebConfig/${idUser}`, 'POST', {WebConfig});
    localStorage.setItem(process.env.REACT_APP_StorageUser, JSON.stringify(result[0]));
    return result;
}

export const getUserByRol = async(IdRol) => {
    const respuesta = await PrivateInterceptor(`IT/Users/usuariosByRol/${IdRol}`, 'GET')
    return respuesta;
}

// MODIFICA UN USUARIO
export const updateUser = async(user) => {
    const respuesta = await PrivateInterceptor(`IT/Users`, 'PUT', user)
    return respuesta;
}


// MODIFICAR CONTRASEÑA DE UN USUARIO
export const updatePassword = async(user) => {
    const respuesta = await PrivateInterceptor(`IT/Users/password`, 'PUT', user)
    return respuesta;
}


// OBTENER TODOS LOS dbo.User con su ID, UserName, Usuario
export const getUsersBasic = async() => {
    const respuesta = await PrivateInterceptor(`IT/Users/seleccionUsuarios`, 'GET')
    return respuesta;
}